<template>
  <div v-if="result" class="product-installments">
    <DefSelectWrapper v-if="result.payData" class="product-installments__size">
      <template #header>
        {{ result.payData.PARTS_COUNT }}
      </template>
      <template v-if="messages" #placeholder>
        {{ messages.term }}
      </template>
      <div v-for="month in getMonthsArray" @click="changeMonth(month)">
        {{ month }}
      </div>
    </DefSelectWrapper>

    <ProductInstallmentsRange
      v-if="screenWidth >= 768"
      :result="result"
      :start="banksStartMonth[result.CODE]"
    />
    <ProductInstallmentsProps v-if="result.payData" :result="result.payData" />
  </div>
</template>

<script></script>

<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from '@store';

import DefSelectWrapper from '@components/Def/DefSelect/DefSelectWrapper.vue';
import { screenWidth } from '@use/useDeviceInfo';
import ProductInstallmentsRange from './ProductInstallmentsRange';
import ProductInstallmentsProps from './ProductInstallmentsProps';

const { result } = defineProps(['result']);

const banksStartMonth = {
  PRIVATBANK: 2,
  PRIVATBANK_PP: 3,
  MONOBANK: 3,
};

const { psInputCode } = result;

const { state, dispatch, commit } = useStore();

const messages = computed(() => state.product.data.messages);
const quantity = computed(() => state.product?.data?.product?.price?.quantity);

const getMonthsArray = computed(() => {
  const arr = [];
  for (let i = banksStartMonth[result.CODE]; i <= result.payData.MAX_PARTS_COUNT; i++) {
    arr.push(i);
  }
  return arr;
});
const otherPaySystemsRequestData = computed(() => {
  const paySystems = state.product.data.product.paySystem.items.filter(
    (el) => el.psInputCode !== psInputCode
  );
  const requestData = {};
  paySystems.map((el) => {
    requestData[el.psInputCode] = el.payData.PARTS_COUNT;
  });
  return requestData;
});

const setPartsCount = (PARTS_COUNT) => {
  // 'ORDER_PROP_29' - property PrivatBank in Bitrix, where you can find settings of the prop and choose correct ORDER_PROP_ID
  // https://sova2-3.bi3x.org/bitrix/admin/sale_order_props_edit.php?lang=ru&ID=29&filter=Y&set_filter=Y
  dispatch('product/updatePageData', {
    ...otherPaySystemsRequestData.value,
    [psInputCode]: PARTS_COUNT,
    quantity: quantity.value,
  });
  // commit('checkout/setRequestData', { name : result.psOrderProp, value: JSON.stringify( partsCount ) });
};

const changeMonth = (month) => {
  setPartsCount(month);
  // dispatch('checkout/setAjax');
};
</script>

<style lang="scss" scoped>
.product-installments {
  &__size {
    margin-bottom: 24px;
    @include point-md {
      max-width: 200px;
    }
  }
}
</style>
